import { h, render, Component } from 'preact';


const twitter = (props) => (
	<svg id="twitter" version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" viewBox="0 0 72 72" class={props.class}>
		<path d="M70,14.9c-2.5,1.1-5.2,1.9-8,2.2c2.9-1.7,5.1-4.5,6.1-7.7c-2.7,1.6-5.7,2.8-8.9,3.4c-2.5-2.7-6.2-4.4-10.2-4.4c-7.7,0-14,6.2-14,14c0,1.1,0.1,2.2,0.4,3.2c-11.6-0.6-21.9-6.1-28.8-14.6c-1.2,2.1-1.9,4.5-1.9,7c0,4.8,2.5,9.1,6.2,11.6c-2.3-0.1-4.4-0.7-6.3-1.7V28c0,6.8,4.8,12.4,11.2,13.7c-1.2,0.3-2.4,0.5-3.7,0.5c-0.9,0-1.8-0.1-2.6-0.3c1.8,5.5,6.9,9.6,13,9.7c-4.8,3.7-10.8,6-17.3,6c-1.1,0-2.2-0.1-3.3-0.2c6.2,4,13.5,6.3,21.4,6.3c25.7,0,39.7-21.3,39.7-39.7c0-0.6,0-1.2,0-1.8C65.8,20.2,68.1,17.7,70,14.9z" />
	</svg>
);

export default twitter;


// WEBPACK FOOTER //
// ../q-components/components/icons/socialIcons/twitter/index.js